/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressRequest } from './AddressRequest';
import {
    AddressRequestFromJSON,
    AddressRequestFromJSONTyped,
    AddressRequestToJSON,
    AddressRequestToJSONTyped,
} from './AddressRequest';

/**
 * Request to update the postal address of a person
 * @export
 * @interface AddressPersonRequest
 */
export interface AddressPersonRequest {
    /**
     * 
     * @type {AddressRequest}
     * @memberof AddressPersonRequest
     */
    address?: AddressRequest;
    /**
     * 
     * @type {string}
     * @memberof AddressPersonRequest
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddressPersonRequest
     */
    isFavorite?: boolean;
}

/**
 * Check if a given object implements the AddressPersonRequest interface.
 */
export function instanceOfAddressPersonRequest(value: object): value is AddressPersonRequest {
    return true;
}

export function AddressPersonRequestFromJSON(json: any): AddressPersonRequest {
    return AddressPersonRequestFromJSONTyped(json, false);
}

export function AddressPersonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressPersonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'] == null ? undefined : AddressRequestFromJSON(json['address']),
        'note': json['note'] == null ? undefined : json['note'],
        'isFavorite': json['isFavorite'] == null ? undefined : json['isFavorite'],
    };
}

export function AddressPersonRequestToJSON(json: any): AddressPersonRequest {
    return AddressPersonRequestToJSONTyped(json, false);
}

export function AddressPersonRequestToJSONTyped(value?: AddressPersonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': AddressRequestToJSON(value['address']),
        'note': value['note'],
        'isFavorite': value['isFavorite'],
    };
}

